import React, { FC } from "react";

// UI components
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
} from "@UI/Components/Accordion/Accordion";
import { Box } from "@UI/Components/Box/Box";
import { Icon } from "@UI/Components/Icon/Icon";
import { Plus } from "@UI/Components/Icons/Plus";
import { Minus } from "@UI/Components/Icons/Minus";

// i18n
import { Bold } from "@UI/Components/Bold/Bold";
import { useFAQQuestions } from "@modules/CustomerSupport/hooks/useFAQQuestions";

export const FAQ: FC = () => {
  const { questions } = useFAQQuestions();

  if (!questions) return null;

  return (
    <Accordion allowToggle>
      {questions.map(({ question, answer }, index) => (
        <AccordionItem
          key={`question-${index}`}
          borderTop={index === 0 && "none"}
        >
          {({ isExpanded }) => (
            <>
              <AccordionButton
                padding="6"
                color={isExpanded ? "pink.500" : "inherit"}
              >
                <Box flex="1" textAlign="left">
                  <Bold>{question}</Bold>
                </Box>

                <Box paddingLeft="6" color="gray.700">
                  {isExpanded ? <Icon as={Minus} /> : <Icon as={Plus} />}
                </Box>
              </AccordionButton>
              <AccordionPanel paddingBottom="8" paddingX="6" paddingTop="0">
                {answer}
              </AccordionPanel>
            </>
          )}
        </AccordionItem>
      ))}
    </Accordion>
  );
};
